import { render } from "./PersonalSubscription.vue?vue&type=template&id=125f6008&scoped=true"
import script from "./PersonalSubscription.vue?vue&type=script&lang=js"
export * from "./PersonalSubscription.vue?vue&type=script&lang=js"

import "./PersonalSubscription.vue?vue&type=style&index=0&id=125f6008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125f6008"]])

export default __exports__